import Layout from "components/layout";
import { campaignTelFortuneIds } from "features/campaigns/constants";
import { useFavorite } from "features/shared/hooks/useFavorite";
import Link from "next/link";
import { ReactNode } from "react";
import { useTelFortunes } from "repositories/hooks";
import { MenuGallelyCard } from "shared/features/Menu/components/MenuGallelyCard";
import tw from "twin.macro";
import { Paths } from "utils/routes";

const Description = tw.p`font-base text-[13px] tracking-[.81px] leading-[21px]`;

/**
 * ページ概要: https://github.com/RAPS-Inc/miror_frontend/issues/3265
 */
const CampaignTelFortune2 = () => {
  const { telFortunes } = useTelFortunes({
    ids: campaignTelFortuneIds,
    sortBy: "sales_quantity",
  });
  const { onClickFavorite } = useFavorite();

  return (
    <div tw="pb-24">
      <div tw="mt-[46px] pt-0 px-5">
        <section>
          <p tw="font-semibold text-2xs tracking-[.41px] text-[#FE4FD0] text-center">
            お持ちのクーポン利用で2000円分無料
          </p>
          <h1 tw="font-bold text-[22px] tracking-[1.83px] text-black text-center">
            クーポン対象占い師
          </h1>
          <Description tw="mt-4">
            MIRORの中でも特に電話鑑定満足度の高い上位占い師約30名を厳選しました。この機会にぜひ、高品質な電話鑑定をお楽しみください。
          </Description>
          <ul tw="grid grid-flow-row grid-cols-2 gap-y-8 gap-x-4 mt-9">
            {telFortunes.map((telFortune) => (
              <li key={telFortune.id}>
                <Link href={Paths.telFortunes.show(telFortune.id)}>
                  <a>
                    <MenuGallelyCard
                      menu={telFortune}
                      onClickFav={onClickFavorite}
                      hasFreeUsage
                    />
                  </a>
                </Link>
              </li>
            ))}
          </ul>
        </section>

        <section tw="mt-20">
          <h2 tw="font-bold text-lg tracking-[1.2px] leading-none text-black text-center">
            クーポン概要・注意事項
          </h2>
          <Description tw="mt-5">
            本ページからの新規登録で、0円~電話鑑定をお楽しみいただけるクーポンを配布させていただきます。
            <br />
            <br />
            有効期限 : クーポン付与から1ヶ月間
            <br />
            <br />
            適用条件 :
            お申し込み時、決済画面にて「クーポンを使用する」にチェックを入れてお申し込みください。
            <br />
            <br />
            注意事項 :<br />
            ・電話鑑定がキャンセルになった場合、クーポンの有効期限内であれば、クーポンが返還されます。
            <br />
            ・おひとり様1回までのご利用となります。
            <br />
            ・1分あたりの料金の他に、別途通話料30円/分がかかります。通話終了時に、通話分数に応じた合計金額からクーポン割引の2000円分の金額が引かれた金額が決済されます。
            <br />
            ・複数アカウントからのお申し込み等、同一人物と思われる方からのお申し込みであることが判明した場合は対象外となります。
            <br />
            ・電話が繋がらなかった等、お困りのことがありましたら運営までお問い合わせください。
          </Description>
        </section>
      </div>
    </div>
  );
};

CampaignTelFortune2.getLayout = (page: ReactNode) => {
  return <Layout nav={null}>{page}</Layout>;
};

export default CampaignTelFortune2;
